/**
 * A cost as the HUD writes it: "90🌾 90🪵", one icon per resource (the glyphs
 * of `view/resources.ts`). Given the viewer's `stock`, the part they can't
 * afford is tinted and also spelled out for screen readers ("short 12 wood").
 */
import { costParts, resourceIcon, shortfallText } from '@/game/view/resources';

export function Cost({
  cost,
  stock,
  className = '',
}: {
  cost: Readonly<Record<string, number>>;
  stock?: Readonly<Record<string, number>>;
  className?: string;
}) {
  const parts = costParts(cost, stock);
  const short = shortfallText(parts);
  return (
    <span className={`whitespace-nowrap tabular-nums ${className}`}>
      {parts.map((p, i) => (
        <span
          key={p.res}
          className={
            p.short > 0
              ? 'font-medium text-danger underline decoration-dotted underline-offset-2'
              : undefined
          }
        >
          {i > 0 && ' '}
          {p.amount}
          {resourceIcon(p.res)}
        </span>
      ))}
      {short && <span className="sr-only">, {short}</span>}
    </span>
  );
}
